import {
  Component,
  ContentChild,
  HostListener,
  OnInit,
  TemplateRef,
} from '@angular/core';

import { Store } from '@ngrx/store';
import { SubSink } from 'subsink';

import { UserService } from '@authentication/services/user.service';
import { AuthenticationSelectors } from '@authentication/store/authentication.slice';
import { Country } from '@products/interfaces/country';
import { SearchCategorySelectComponent } from '@search/components/search-category-select/search-category-select.component';
import { PriceSearchSubformComponent } from '@search/components/sub-components/price-search-subform/price-search-subform.component';
import { SelectorSubformComponent } from '@search/components/sub-components/selector-subform/selector-subform.component';
import { SearchRequest } from '@search/interfaces/search-request.intarface';
import {
  ProductSearchActions,
  ProductSearchSelectors,
} from '@search/store/search.slice';
import { paginatorConfiguration } from '@shared/constants/paginator-configuration';
import { standaloneSubtypes } from '@shared/enums/packaging-subtype';
import { SearchFilter } from '@shared/interfaces/search-filter.interface';

@Component({
  selector: 'app-search-container',
  templateUrl: './search-container.component.html',
  styleUrls: ['./search-container.component.scss'],
})
export class SearchContainerComponent implements OnInit {
  @ContentChild(TemplateRef) searchNavbar!: TemplateRef<any>;
  authChecked = false;
  screenWidth!: number;

  subs = new SubSink();

  searchValue: SearchRequest = {};

  searchFieldList: Array<SearchFilter> = [];
  searchAction = ProductSearchActions.searchProducts;
  updateSearchValueAction = ProductSearchActions.updateSearchValue;
  pageSize: number = paginatorConfiguration.searchPageSizeOptions[0];

  selectedSiteId!: string;
  merchantType!: string;

  constructor(private userService: UserService, private store: Store) {
    this.getScreenSize();
  }

  ngOnInit() {
    this.subs.add(
      this.store
        .select(AuthenticationSelectors.selectUserInfo)
        .subscribe((userInfo) => {
          if (
            this.selectedSiteId !==
              userInfo.attributes?.['custom:selectedSiteId'] ||
            userInfo.attributes?.['custom:selectedMerchantType'] !==
              this.merchantType
          ) {
            this.selectedSiteId =
              userInfo.attributes?.['custom:selectedSiteId'];
            this.merchantType =
              userInfo.attributes?.['custom:selectedMerchantType'];
            this.store.dispatch(ProductSearchActions.getBrands.trigger());
          }
        })
    );

    this.subs.add(
      this.store
        .select(ProductSearchSelectors.selectSearchValue)
        .subscribe((value) => {
          if (value) {
            this.searchValue = value;
          }
        })
    );

    this.userService.getUserAsync().then((user) => {
      if (!!user) {
        // nem bejelentkezett felhasználó nem szűrhet az árazásra
        this.searchFieldList = !!user
          ? [
              // TODO Szerintem ez nem kell már
              /*{
                name: SearchInputComponent,
                title: '',
                property: '',
                isGeneric: false,
              },*/
              {
                name: SearchCategorySelectComponent,
                title: 'SEARCH.SEARCH_BAR.TITLE.DRINK_TYPE',
                property: 'drinkTypeList',
                isGeneric: true,
                data: {
                  additionalUpdater: ProductSearchActions.getBrands,
                },
              },
              {
                name: SelectorSubformComponent,
                title: 'SEARCH.SEARCH_BAR.TITLE.BRAND',
                property: 'brandList',
                isGeneric: true,
                data: {
                  isMultiple: true,
                  asyncOptionsSelector: ProductSearchSelectors.selectBrands,
                  showSelectedLabels: true,
                  filter: this.searchValue,
                },
              },
              {
                name: PriceSearchSubformComponent,
                title: '',
                property: '',
                isGeneric: false,
              },
              // Átmenetileg, míg nem kezeljük telephelyi profil szerint a felhasználókat
              /*{
                name: CheckboxSubformComponent,
                title: 'SEARCH.SEARCH_BAR.TITLE.PAYMENT_METHOD',
                property: 'paymentMethods',
                isGeneric: true,
                data: {
                  filter: this.searchValue,
                  checkboxOptions: PaymentMethodTypes,
                  optionTitlePrefix: 'SEARCH.SEARCH_BAR.PAYMENT_METHOD.',
                },
              },*/
              {
                name: SelectorSubformComponent,
                title: 'SEARCH.SEARCH_BAR.TITLE.PACKAGING_TYPE',
                property: 'packingMethodSubTypeList',
                isGeneric: true,
                data: {
                  isMultiple: true,
                  enum: standaloneSubtypes.map((type) => ({
                    name: 'PACKAGING.NEW.SUBTYPE.STANDALONE.' + type,
                    value: type,
                  })),
                  labelAttribute: 'name',
                  valueAttribute: 'value',
                  filter: this.searchValue,
                },
              },
              {
                name: SelectorSubformComponent,
                title: 'SEARCH.SEARCH_BAR.TITLE.PLACE_OF_ORIGIN',
                property: 'placeOfOriginList',
                isGeneric: true,
                data: {
                  isMultiple: true,
                  enum: Object.values(Country).map((country) => ({
                    name: 'COUNTRY.' + country,
                    value: country,
                  })),
                  labelAttribute: 'name',
                  valueAttribute: 'value',
                  filter: this.searchValue,
                },
              },
            ]
          : [
              {
                name: SearchCategorySelectComponent,
                title: 'SEARCH.SEARCH_BAR.TITLE.DRINK_TYPE',
                property: 'drinkTypeList',
                isGeneric: true,
                data: {
                  additionalUpdater: ProductSearchActions.getBrands,
                },
              },
              {
                name: SelectorSubformComponent,
                title: 'SEARCH.SEARCH_BAR.TITLE.BRAND',
                property: 'brandList',
                isGeneric: true,
                data: {
                  isMultiple: true,
                  asyncOptionsSelector: ProductSearchSelectors.selectBrands,
                  showSelectedLabels: true,
                  filter: this.searchValue,
                },
              },
              // Átmenetileg, míg nem kezeljük telephelyi profil szerint a felhasználókat
              /*{
                name: CheckboxSubformComponent,
                title: 'SEARCH.SEARCH_BAR.TITLE.PAYMENT_METHOD',
                property: 'paymentMethods',
                isGeneric: true,
                data: {
                  filter: this.searchValue,
                  checkboxOptions: PaymentMethodTypes,
                  optionTitlePrefix: 'SEARCH.SEARCH_BAR.PAYMENT_METHOD.',
                },
              },*/
              {
                name: SelectorSubformComponent,
                title: 'SEARCH.SEARCH_BAR.TITLE.PACKAGING_TYPE',
                property: 'packingMethodSubTypeList',
                isGeneric: true,
                data: {
                  isMultiple: true,
                  enum: standaloneSubtypes.map((type) => ({
                    name: 'PACKAGING.NEW.SUBTYPE.STANDALONE.' + type,
                    value: type,
                  })),
                  labelAttribute: 'name',
                  valueAttribute: 'value',
                  filter: this.searchValue,
                },
              },
              {
                name: SelectorSubformComponent,
                title: 'SEARCH.SEARCH_BAR.TITLE.PLACE_OF_ORIGIN',
                property: 'placeOfOriginList',
                isGeneric: true,
                data: {
                  isMultiple: true,
                  enum: Object.values(Country).map((country) => ({
                    name: 'COUNTRY.' + country,
                    value: country,
                  })),
                  labelAttribute: 'name',
                  valueAttribute: 'value',
                  filter: this.searchValue,
                },
              },
            ];
      }
      this.authChecked = true;
    });
  }

  @HostListener('window:resize', ['$event']) getScreenSize() {
    this.screenWidth = window.innerWidth;
  }
}
